
import { Component, Prop, Vue } from "vue-property-decorator";
import Table from "@/domain/restaurant/Table";
import Room from "@/domain/restaurant/Room";

@Component
export default class BookingOverviewComponentTable extends Vue {
  @Prop({ default: null })
  table!: Table | null;

  @Prop({ default: "" })
  icon!: string;

  @Prop({ default: "" })
  iconColour!: string;

  @Prop({ default: false })
  hideActions!: boolean;

  showTableChangeDialog = false;

  get tableName() {
    if (this.table != null) return this.table?.tableName;
    else {
      return this.$t("booking.table.not.selected");
    }
  }

  get roomColour() {
    if (this.table != null && this.table?.roomId != null)
      return Room.getRoomColourFromId(this.table?.roomId);
    return "red";
  }

  showBookingChangeTableDialog() {
    this.$emit("booking-change-table-dialog");
  }
}
